<div class="trace-viewer">
  <biz-filters [showLoading]="showLoading" (emitFilter)="getFilesNames($event)" (emitIsCollapse)="collapse($event)" class="filters_content"></biz-filters>

  <div class="trace-viewer__table">
    <bz-loading [size]="'xl'"  class="bzg-loading-trace" *ngIf="showLoading"><strong class="bz-font-size--body-small">{{loadingMessage}}</strong>
    </bz-loading>

    <div *ngIf="!showLoading && traces.length > 0">
      <biz-table [traces]="traces" [isCollapsed]="isCollapsed" [isDownloading]="isDownloading" [isDeleting]="isDeleting"
        [selectedTraces]="selectedTraces" (emitSelectedDownload)="download($event)" 
        (emitSelectedDeleted)="delete($event)" (emitSelectedTrace)="showViewerDialog($event)"></biz-table>
    </div>

    <div class="trace-viewer__no-records" *ngIf="!showLoading && traces.length === 0 && !exceedsResultLimit">
      <img class="trace-viewer__img" src="assets/img/no_found.png">
      <span>{{ 'TRACE.NO_RECORDS' | translate}}</span>
    </div>
    <div class="trace-viewer__no-records" *ngIf="!showLoading && traces.length === 0 && exceedsResultLimit">
      <img class="trace-viewer__img" src="assets/img/no_found.png">
      <span>{{ 'TRACE.ERROR_FILTER' | translate}}</span>
    </div>
  </div>
</div>
